// @ts-nocheck
import { useState, useCallback } from 'react';

interface AddressData {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string; // Cidade
  uf: string; // Estado
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

interface CityData {
  id: number;
  nome: string;
}

export const useAddressLookup = () => {
  const [address, setAddress] = useState<Partial<AddressData>>({});
  const [cities, setCities] = useState<CityData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAddressByCep = useCallback(async (cep: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data: AddressData = await response.json();
      if (data.erro) {
        setError('CEP não encontrado.');
        setAddress({});
      } else {
        setAddress({
          cep: data.cep,
          logradouro: data.logradouro,
          complemento: data.complemento,
          bairro: data.bairro,
          localidade: data.localidade,
          uf: data.uf,
        });
        // Se o estado for encontrado, busca as cidades
        if (data.uf) {
          await fetchCitiesByState(data.uf);
        }
      }
    } catch (err) {
      setError('Erro ao buscar CEP. Verifique a conexão ou o CEP digitado.');
      setAddress({});
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCitiesByState = useCallback(async (stateAbbreviation: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateAbbreviation}/municipios`);
      const data: CityData[] = await response.json();
      if (response.ok) {
        setCities(data.sort((a, b) => a.nome.localeCompare(b.nome)));
      } else {
        setError('Erro ao buscar cidades para o estado.');
        setCities([]);
      }
    } catch (err) {
      setError('Erro ao buscar cidades. Verifique a conexão.');
      setCities([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { address, cities, loading, error, fetchAddressByCep, fetchCitiesByState, setAddress, setCities };
};